// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"text-button_button_wrapper__JigUr","text_button":"text-button_text_button__pYqd6","text_wrapper":"text-button_text_wrapper__bZQz4"};